import {useEffect} from 'react';

import {Box, Grid} from '@mui/material';

import {defaultValues} from './helpers/defaultValues';
import deserializePractitioner from './helpers/deserializePractitioner';
import useEmmai from '../../../../../hooks/providers/useEmmai';
import Button from '../../../../form/buttons/Button/Button';
import SpecialtiesField from '../../../forms-utils/field-types/SpecialtiesField';
import {practitionerCommonInformationFields, practitionerUsedTechnicsFields, practitionerSuppliersFields} from '../../../forms-utils/form-schemas/practitioner';
import {renderFormFields} from '../../../forms-utils/renderFormFields';
import usePractitionerNavigation from '../../shared/usePractitionerNavigation/usePractitionerNavigation';

const EmmaiPractitionerForm = () => {
  const {practitionerFormMethods, submitPractitioner, isPractitionerUpdating, selectedPractitioner, setCurrentForm, setIsPractitionerUpdating} = useEmmai();
  const {formState, control, watch, reset} = practitionerFormMethods;
  const {isSubmitting} = formState;
  const practitionerFormValues = watch();

  const {goToPractitionerActivity} = usePractitionerNavigation({
    setCurrentForm,
    setIsPractitionerUpdating
  });

  useEffect(() => {
    if (isPractitionerUpdating) {
      const deserializedPractitioner = deserializePractitioner(selectedPractitioner);
      reset(deserializedPractitioner);
    }
  }, [isPractitionerUpdating, selectedPractitioner]);

  useEffect(() => {
    const {errors} = formState;
    if (Object.keys(errors).length === 0) return;

    const field = Object.keys(errors)[0];
    const el = document.querySelector(`[name="${field}"]`);

    if (el) {
      el.scrollIntoView({behavior: 'smooth', block: 'center'});
      setTimeout(() => el.focus(), 250);
    }
  }, [formState.errors]);

  return (
    <Box>
      <Grid container spacing={1}>
        {renderFormFields(null, practitionerCommonInformationFields, control, practitionerFormValues)}

        <Grid item xs={12}>
          <SpecialtiesField control={control} />
        </Grid>

        {renderFormFields(null, practitionerUsedTechnicsFields, control, practitionerFormValues)}

        {renderFormFields(null, practitionerSuppliersFields, control, practitionerFormValues)}
      </Grid>

      <Grid container mt={4} alignItems="center" spacing={1} justifyContent="center">
        <Grid item>
          <Button color="error" onClick={goToPractitionerActivity} size="small" variant="outlined">
            Annuler
          </Button>
        </Grid>
        {isPractitionerUpdating ? null : (
          <Grid item>
            <Button disabled={isSubmitting} size="small" variant="outlined" onClick={submitPractitioner}>
              Ajouter le praticien
            </Button>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default EmmaiPractitionerForm;
